// Custom Imports
// =========================================================
import { FormatKey } from 'src/app/utils/global_functions'
import { CellClassRules } from '../02_global-settings/cell-class-rules'
import { FormatDate, GenerateDefaultColDefs } from '../02_global-settings/global-cell-formatter'
import { type ValueFormatterParams, type ICellRendererParams } from 'ag-grid-community'

export interface RecoBuyQtyRepo_GridDataParams {
  mainColDefs: any[]
  // detialColDefs: any[];
}

export async function RecoBuyQtyRepo_GenerateGridData (params: RecoBuyQtyRepo_GridDataParams) {
  const {
    mainColDefs
    // detailColDefs
  } = params

  const GenerateCols = async (data: any[], gridToRender: string) => {
    const mappedCols = {}

    Object.entries(data).map(([colKey, colVal]) => {
      const colId = colVal.refData?.custom_field || FormatKey(colKey)

      const obj = {
        ...GenerateDefaultColDefs(colKey, { colId, ...colVal })
      }
      Object.assign(mappedCols, {
        [obj.colId]: RecoBuyQtyRepo_customCellFormatting(obj, gridToRender)
      })
    })

    return Object.values(mappedCols)
  }

  const getResults = async () => {
    const mainCols = await GenerateCols(mainColDefs, 'main')

    const results = await Promise.all([mainCols])
    const m = results.indexOf(mainCols)

    const data = {
      mainColDefs: results[m]
    }
    return data
  }
  return await getResults()
}

export const RecoBuyQtyRepo_customCellFormatting = (col, gridToRender) => {
  const hasValue = val => val && ((val !== '' && val !== undefined) || val !== null)
  const getParams = () => {
    // Main Grid Settings
    if (gridToRender === 'main') {
      console.log('rendering column', col.colId)
      switch (col.colId) {
        case 'open':
          return {
            showHeader: false,
            cellRendererParams: (params: ICellRendererParams) => {
              return {
                toolTipMessage: `Open plan: ${params.data.plan_name}`,
                onClick: () => params.context.getPlan(params.data.plan_name)
              }
            }
          }
        case 'delete':
          return {
            cellRendererParams: (params: ICellRendererParams) => {
              return {
                toolTipMessage: `Delete plan: ${params.data.plan_name}`,
                onClick: () => params.context.deletePlan(params.data.plan_name)
              }
            }
          }
        case 'created_at':
        case 'last_modified':
          return {
            valueFormatter: FormatDate
          }
        default:
          // if (col.refData.datatype === 'currency') {
          //   return {
          //     valueFormatter: (params: ValueFormatterParams) => params.value.startsWith('$') ? params.value : '$' + params.value
          //   }
          // }
          return {
            valueFormatter: (params: ValueFormatterParams) => params.value
          }
      }
    }
    // Detail Grid Settings
    // if (gridToRender === 'detail') {
    // }
  }
  const updatedCol = {
    ...col,
    ...getParams(),
    cellClassRules: {
      ...CellClassRules
    }
  }
  return updatedCol
}
